

export default processName;
import { quote } from '../mappers';
function processName(name) {
	return name ? quote(name) + ', ' : '';
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/amd/processName.js.01-babel.map